import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import { BomBatchUpdateType } from '@schemas'

// todo: return 타입 정의 필요
export const getBOM = async ({
	params = {},
	body = {},
	query = { productId: '' },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/bom'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const batchUpdateBOM = async ({
	body = { bomList: [] as BomBatchUpdateType[] },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	const uri = '/bom/batch-update'
	const req = new ApiRequest({
		method: 'put',
		uri: uri,
		body: body,
		customHeaders: customHeaders,
	})

	try {
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const bomApi = {
	getBOM: getBOM,
	batchUpdateBOM: batchUpdateBOM,
}

export default bomApi
